export default function () {
  /* 表格列头：统一用 min-width，剩余宽度按内容长度比例分配，整行铺满、间隔均匀 */
  return [
    {
      label: "",
      type: "selection",
      width: 56,
    },
    {
      label: "店铺名称",
      prop: "store_name",
      slots: "storeName",
      minWidth: 240,
    },
    {
      label: "店长openid",
      prop: "openid",
      slots: "openid",
      minWidth: 220,
    },
    {
      label: "店长",
      prop: "boss_name",
      slots: "bossName",
      minWidth: 130,
    },
    {
      label: "标签",
      prop: "tag",
      slots: "tag",
      minWidth: 100,
    },
    {
      label: "等级",
      prop: "grade",
      slots: "grade",
      minWidth: 100,
    },
    {
      label: "到期时间",
      prop: "vip_date",
      slots: "vipDate",
      minWidth: 120,
    },
    {
      label: "操作",
      prop: "operation",
      minWidth: 150,
      slots: "operation",
    },
  ];
}
